import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {
  getBizList,
  getCmsList,
  getCourseList,
  getOfflineCourseList
} from "../../api/service.js"
import {
  eUrl
} from "@/api/baseURL.js";
import $ from 'jquery'
export default {
  components: {
    myHeader,
    myFooter
  },

  data() {
    return {
      BannerList: [],
      noDataShow: true,
      onlineCourse: '', //在学课程
      studyTimeRankingList: [],
      generalMyNewsList: [],
      headlineMyNewsList: [],
      generalIndustryNewsList: [],
      headlineIndustryNewsList: [],
      catetoryPatentList: [],
      catetoryIndex: 0,
      bannerList: [],
      // activeName: '全部课程',  //标签tabs默认第一个
      onlineCoursesList: [], //线上课程
      offlineCoursesList: [ //线下课程
      ],
      offlineCatetoryIndex: 0,
      offlineCourses: [],
      onlineTotal: 0,
      publicCourseList: [ //公共课程部分数据
        {
          title: "全部课程",
        },
      ],
      empHeadportrait: '', //头像
      empName: '', //姓名
      empOnlinetime: '', //在线累计时长
      empIssueCourse: '', //已开通课
      userSturyTotalHourse: '0时0分0秒', //学习时长
      MustCourseCount: 0,
      noStudyCourse: 0,
      overCourse: 0,
      pageSize: 8,
      pageNum: 1,
      aa: false,
      bb: false,
      isLogin: true,
      catetoryList: [],
      offlineTotal: 0,
      offlinePageSize: 4,
    }
  },
  created() {
    if (localStorage.getItem('tokenId') == undefined || localStorage.getItem('tokenId') == "") {
      this.getEnterpriseWebsite()
      this.isLogin = false
      //   this.offlineCourses=this.offlineCoursesList[0].list
    } else {
      this.getStudyTimeRankingList()
      this.getMyNews()
      this.getIndustryNews()
      this.getEmployeeDetail()
      this.getBannerList()
      this.getStudyTime()
      this.getCourseCatetoryPatent()
      this.getCourseCatetoryPatentSubset()
      //   this.offlineCourses=this.offlineCoursesList[0].list
      this.getOfflineCourseList()
    }

  },
  mounted() {
    var publicCourse = document.getElementsByClassName("in-bannerBox")
    publicCourse.style.minHeight = document.body.scrollHeight - 90 - 257 + "px"
  },
  methods: {
    getEnterpriseWebsite() { //根据域名获取企业id
      // var eUrl = window.location.href;
      // var eUrl = 'http://snyg.e.eceping.net';

      //var eUrl="http://ykxy.enterprise.eceping.net"
      var param = {
        entpWebsite: eUrl /*eUrl.substring(0,eUrl.indexOf(":",5))*/
      };
      let url = "enterprise/getEnterpriseWebsite"
      getBizList(url, param).then(res => {
        if (res.success) {
          localStorage.setItem("enterpriseId", res.data.entpId)
          localStorage.setItem("entpCreditNo", res.data.entpCreditNo)
          this.getMyNews();
          this.getIndustryNews();
          // this.getBusinessCoursesList();
          this.getBannerList();
          this.getEnterpriseLog();
          this.getCourseCatetoryPatent();
          this.getCourseCatetoryPatentSubset();
          // this.offlineCourses=this.offlineCoursesList[0].list
          this.getOfflineCourseList()
          this.getStudyTimeRankingList()
        }
      })
    },
    //获取浏览器图标 
    getEnterpriseLog() {
      let url = "enterprise/enterpriseInformation"
      getBizList(url).then(res => {
        if (res.success) {
          sessionStorage.setItem("webIco", res.data.webIco)
          sessionStorage.setItem("webIeIco", res.data.webIeIco)
          if (res.data.webIco) {
            $("#enterpriseLogo").attr("src", res.data.webIco)
          }
          if (res.data.webIeIco) {
            $("#browserIcon").attr("href", res.data.webIeIco)
          }
          if (res.data.empName) {
            document.title = res.data.empName
          }
        }
      })
    },
    //获取个人信息
    getEmployeeDetail() {
      let url = "employee/getEmployeeInformation"
      getBizList(url).then(res => {
        // console.log("人员信息",res)
        if (res.code == 0) {
          let data = res.data
          this.empHeadportrait = data.empHeadportrait ? data.empHeadportrait : "../../../static/empHeadportrait.png"
          localStorage.setItem("empHeadportrait", this.empHeadportrait)
          this.empName = data.empName
          localStorage.setItem("empTel", data.empTel)
          localStorage.setItem("empName", this.empName)
          localStorage.setItem("empCategory", data.empCategory)
        }
      })
    },
    //获取学习时长
    getStudyTime() {
      let url = "/home/getMustAndStartingCourse"
      getCourseList(url).then(res => {
        // console.log("学习时长",res)
        if (res.success) {
          let data = res.data
          this.userSturyTotalHourse = data.userSturyTotalHourse ? data.userSturyTotalHourse : 0
          this.onlineCourse = data.onlineCourse ? data.onlineCourse : 0
          this.MustCourseCount = data.MustCourseCount ? data.MustCourseCount : 0
          this.noStudyCourse = data.noStudyCourse ? data.noStudyCourse : 0
          this.overCourse = data.overCourse ? data.overCourse : 0
        }
      })
    },
    //获取banner图
    getBannerList() {
      let url = "banner/getGatewayHomeBannerList"
      getBizList(url).then(res => {
        console.log("banner列表", res)
        if (res.success) {
          this.bannerList = res.data
        }
      })
    },
    //获取学习时长排行榜
    getStudyTimeRankingList() {
      let url = "employee/getStudyTimeRankingList"
      getBizList(url).then(res => {
        //    console.log("获取学习时长排行榜",res)
        if (res.code == 0) {
          for (var i = 0; i < res.data.length; i++) {
            let item = res.data[i]
            item.empHeadPortrait = item.empHeadPortrait ? item.empHeadPortrait : "../../../static/empHeadportrait.png"
          }
          this.studyTimeRankingList = res.data;
        }
        // console.log("jkjifjieiiieeii",this.studyTimeRankingList)
      })
    },
    //获取站内新闻
    getMyNews() {
      let url = "news/getMyNews"
      getCmsList(url).then(res => {
        // console.log("站内新闻",res)
        if (res.code == 0) {
          this.generalMyNewsList = res.data.generalNewsList
          this.headlineMyNewsList = res.data.headlineNewsList
        }
      })
    },
    //获取行业资讯
    getIndustryNews() {
      let url = "news/getIndustryNews"
      getCmsList(url).then(res => {
        // console.log("行业资讯",res)
        if (res.code == 0) {
          this.generalIndustryNewsList = res.data.generalNewsList
          this.headlineIndustryNewsList = res.data.headlineNewsList
        }
      })
    },
    handleClick(tab, event) {},
    //进课程详情
    GotoCourseDetail(id, orderPackagebagId) {
      this.$router.push({
        path: "/courseDetail",
        query: {
          courseId: id,
          orderPackagebagId: orderPackagebagId,
        }
      });
    },
    GotoNewsDetail(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          newsId: id,
        }
      });
    },
    //banner 图上的课程分类
    getCourseCatetoryPatentSubset() {
      let url = "home/getCourseCatetoryPatentSubsetByTokenId"
      getCourseList(url).then(res => {
        if (res.success) {
          this.catetoryList = res.data
          // let cateId=res.data[0].cateId
        }
      })
    },
    gotoPublicCentre(parentId, childId) {
      this.$router.push({
        path: "/publicCourse",
        query: {
          parentId,
          childId
        }
      });
    },
    goPublicList() {
      this.$router.push({
        path: "/publicCourse",
      });
    },
    // 线上课程
    getCourseCatetoryPatent() {
      let url = "home/getCourseCatetoryPatentFromHome"
      getCourseList(url).then(res => {
        // console.log(res)
        this.catetoryPatentList = res.data
        let cateId = res.data[0].cateId
        this.selectCatetorPatent(cateId, 0)
      })
    },
    selectCatetorPatent(cateId, index) {
      this.catetoryIndex = index
      let url = "/home/getStudyCentreList"
      let data = {
        entpId: "",
        catePatentId: cateId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      getCourseList(url, data).then(res => {
        if (res.success) {
          this.onlineCoursesList = res.data
          this.onlineTotal = res.total
        }
      })
    },
    // 线下课程
    offlineSelectPatent(index) {
      // this.offlineCourses=this.offlineCoursesList[index].list
      this.offlineCatetoryIndex = index
    },
    GotoOfflineCourseDetail(courseId) {
      this.$router.push({
        path: "/offlineCourseDetail",
        query: {
          courseId
        }
      });
    },
    getOfflineCourseList() {
      let url = "enterprise/underline/getUnderlineCourseListFromEnterprise"
      let data = {
        pageNum: 1,
        pageSize: this.offlinePageSize,
        orderby: 0
      }
      getOfflineCourseList(url, data).then(res => {
        if (res.success) {
          this.offlineCoursesList = res.data
          this.offlineTotal = res.total
        }
      })
    },

  }
}



// WEBPACK FOOTER //
// ./src/pages/enterpriseEdition/eeHtml.js